<template>
  <!--  <transition name="fade" mode="out-in">-->
  <router-view></router-view>
  <!--  </transition>-->
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    //
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue